module.exports = __webpack_public_path__ + "static/media/arrow-up.5022aa7e.svg";